import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useTopics(data = {}) {
  const { enabled = false, configs = {}, classID, topicID, courseID, chapterID } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getTopicDetails() {
    return privateFetch
      .get(
        `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}/topic/${topicID}`,
        configs
      )
      .then((res) => res.data);
  }

  return useQuery(['topic-details', topicID, { data }], getTopicDetails, { enabled });
}

export default useTopics;
